import { ChangeDetectorRef, ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { FikoOperasyon } from '../FikoThreeCam/Fikoperasyon';
import { FikoYTService } from '../../../../../../fikoyt.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FikoEksenComponent } from '../fiko-eksen/fiko-eksen.component';
import { FikoKutuk } from '../FikoKutuk';
import { FikoKutukComponent } from '../fiko-kutuk/fiko-kutuk.component';

@Component({
  selector: 'fikoyt-fikoperasyon',
  templateUrl: './fikoperasyon.component.html',
  styleUrls: ['./fikoperasyon.component.scss'],
  imports: [CommonModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FikoperasyonComponent implements OnDestroy {
  subsList: Subscription[] = [];

  @Input() fikoperasyon: FikoOperasyon;
  @Input() pencere: any;

  constructor(public readonly FikoYT: FikoYTService, public readonly CD: ChangeDetectorRef) {
    this.subsList.push(FikoYT.degisti.subscribe(() => {
      this.CD.markForCheck();
    }));
  }

  tiklandiEksenSecimi() {
    this.fikoperasyon?.sahne?.anaGosterim?.DialogFiko?.ac({
      bilesen: FikoEksenComponent,
      parametreler: { eksen: this.fikoperasyon?.islemeEkseni },
      $event: null,
      ayarlar: { baslik: 'İşleme Ekseni', simgeResim: './simgeler/xyz-1.webp' }
    });
  }

  async tiklandi3DSec() {
    const obje: any = await (this.fikoperasyon?.sahne as any)?.cizimler?.ekleDosyadan();
    if (obje) {
      if (!this.fikoperasyon?.userData['cizimler'])
        this.fikoperasyon.userData['cizimler'] = [];
      this.fikoperasyon?.userData['cizimler'].push(obje.uuid);
    }
  }

  // ─── Kutuk Secimi ─────────────────────────────────────────────────

  get mevcutKutukler(): FikoKutuk[] {
    return this.fikoperasyon?.kutukleriBul() ?? [];
  }

  get seciliKutuk(): FikoKutuk | null {
    return this.fikoperasyon?.seciliKutuk ?? null;
  }

  tiklandiKutukSec(kutuk: FikoKutuk) {
    this.fikoperasyon?.kutukSec(kutuk);
    this.CD.markForCheck();
  }

  tiklandiKutukTemizle() {
    this.fikoperasyon?.kutukSec(null);
    this.CD.markForCheck();
  }

  tiklandiKutukDuzenle() {
    const kutuk = this.seciliKutuk;
    if (!kutuk) return;
    this.fikoperasyon?.sahne?.anaGosterim?.DialogFiko?.ac({
      bilesen: FikoKutukComponent,
      parametreler: { kutuk: kutuk },
      $event: null,
      ayarlar: { baslik: 'Kutuk Ayarlari', simgeResim: './simgeler/kupler.webp' }
    });
  }

  kapa() {
    this.pencere?.kapat();
  }

  ngOnDestroy(): void {
    this.subsList.forEach(s => s.unsubscribe());
  }
}
